import { Skeleton } from '@teamsnap/snap-ui';
import * as React from 'react';

const TableRow = () => (
  <tr className="sui-border-b sui-border-solid sui-border-gray-90">
    <td className="sui-px-2 sui-py-3 sui-pr-[100px]">
      <Skeleton className="sui-w-[400px]" />
    </td>
    <td className="sui-px-2 sui-py-3">
      <Skeleton className="sui-w-[60px]" />
    </td>
    <td className="sui-px-2 sui-py-3">
      <Skeleton className="sui-w-[100px]" />
    </td>
  </tr>
);

export default function OrderDetailsTableSkeleton() {
  return (
    <div
      data-testid="order-details-table-skeleton"
      className="sui-overflow-x-auto"
    >
      <table className="sui-w-full">
        <thead>
          <tr className="sui-border-b-2 sui-border-solid sui-border-gray-90">
            <th className="sui-p-2 sui-pr-[100px]">
              <Skeleton className="sui-w-[110px]" />
            </th>
            <th className="sui-p-2">
              <div className="sui-flex sui-gap-1">
                <Skeleton className="sui-w-[100px]" />
                <Skeleton />
              </div>
            </th>
            <th className="sui-p-2">
              <div className="sui-flex sui-gap-1">
                <Skeleton className="sui-w-[100px]" />
                <Skeleton />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <TableRow />
          <TableRow />
          <TableRow />
          <TableRow />
          <TableRow />
        </tbody>
      </table>
    </div>
  );
}
